const getLieOptions = style => {
    const baseOption = {
        textStyle: {
            fontFamily: 'font-normal',
            fontSize: 12
        },
        tooltip: {
            z: 1,
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    type: 'dotted',
                    width: 2,
                    color: 'rgba(145, 152, 161, 0.5)'
                },
                z: 0
            },
            showContent: true,
            backgroundColor: 'rgba(32, 36, 55, 0.95)',
            padding: [12, 12, 12, 12]
        },
        grid: {
            left: 45,
            right: 30,
            bottom: 30,
            top: 40,
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: true,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: '#8a8d98'
                },
                splitLine: {
                    show: false
                },
                offset: 9
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: '#8a8d98'
                },
                splitLine: {
                    show: false
                },
                splitArea: {
                    show: true,
                    areaStyle: {
                        color: ['#fafafd', '#fff']
                    }
                },
                offset: 23
            }
        ],
        series: {
            type: 'line',
            showSymbol: false,
            symbolSize: 8,
            symbol: 'emptyCircle',
            itemStyle: {
                normal: {
                    color: '#03c9ff',
                    borderColor: '#03c9ff',
                    borderWidth: 4
                }
            },
            lineStyle: {
                normal: {
                    width: 4
                }
            }
        }
    };
    const chartOption = {
        baseOption: baseOption,
        media: [
            {
                query: {
                    maxWidth: 600
                },
                option: {
                    grid: {
                        left: 40,
                        right: 0,
                        bottom: 45,
                        top: 25
                    }
                }
            }
        ]
    };
    return chartOption;
};

export default getLieOptions;
